var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"enter-active-class":_vm.enterActClass ? 'animated ' + _vm.enterActClass : '',"leave-active-class":_vm.leaveActClass ? 'animated ' + _vm.leaveActClass : ''}},[(_vm.show)?_c('div',{staticClass:"transition-box"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }